module.exports = require("@workbench-stack/platform");